import * as React from "react";
import { forwardRef } from "react";
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", fill: "current", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 40 40", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("style", null)), /* @__PURE__ */ React.createElement("path", { className: "cls-1", d: "M30.13,20a1,1,0,0,1-.3.71L11.58,39a1,1,0,0,1-1.41-1.41L27.71,20,10.17,2.45A1,1,0,0,1,11.58,1L29.83,19.29A1,1,0,0,1,30.13,20Z" }));
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
